import React from 'react'
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'
import CustomTooltip from '../../../../../components/CustomTooltip'
import { formatDateByUserTimeZone } from '../../../../../helpers/formatDateByUserTimeZone'
import { SlotStatus } from '../../../../../models/DistributionPlan'
import { chipColors } from '../../../../CoursesAndEnrollment/CourseEvaluationHeader'
import { blue, grey } from '../../../../../colors'
import ROUTES from '../../../../../consts/paths'
import { capitalizeFirst } from '../../../../../utils/utils'

export const ProjectTabPanel: React.FC<{ selectedRow?: any }> = ({ selectedRow }) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {
        !selectedRow?.distributionDetails?.length
          ? <Typography fontWeight={'600'} mb={1}>This section is not linked to any survey projects.</Typography>
          : <>
            <Typography fontWeight={'600'} mb={1}>This section is linked to the following survey projects:</Typography>
            {
              selectedRow?.distributionDetails?.map((project: any) => {
                const formattedStart = project?.startTimestamp && formatDateByUserTimeZone(project.startTimestamp)
                const formattedEnd = project?.endTimestamp && formatDateByUserTimeZone(project.endTimestamp)
                const slotKey = String(project?.slotId ?? project?.slotTitle)
                const chipVariant = project?.slotStatus === SlotStatus.Draft ? 'outlined' : 'filled'
                const chipColor: any = chipColors[typeof project?.slotStatus === 'string' ? project.slotStatus : 'Draft']

                return (
                  <Accordion key={slotKey} sx={{ boxShadow: 'none' }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-${slotKey}-content`}
                      id={`panel-${slotKey}-header`}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: grey[100] },
                        '&.Mui-expanded': { backgroundColor: grey[100], borderRadius: 1 }
                      }}
                    >
                      <Typography fontWeight="bold" fontSize={16}>{capitalizeFirst(project?.slotTitle ?? '')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: 1, my: 2, ml: 1 }}>
                      <Box display='flex' justifyContent={'space-between'} alignItems='center'>
                        <Box display={'flex'} gap={2}>
                          <Typography fontWeight={500} color={grey[600]}>Survey Status:</Typography>
                          <Chip variant={chipVariant} size='small' color={chipColor} label={project?.slotStatus} />
                        </Box>

                        <CustomTooltip title="Go to Survey Project Section">
                          <Typography
                            fontWeight="bold"
                            fontSize={16}
                            sx={{ cursor: 'pointer' }}
                            onClick={e => {
                              e.stopPropagation()
                              window.open(`${ROUTES.COURSE_AND_ENROLLMENT}/${project?.slotId}?search=${selectedRow?.abbreviation}`, '_blank')
                            }}
                          >
                            <OpenInNewOutlinedIcon sx={{ color: blue[500] }} />
                          </Typography>
                        </CustomTooltip>
                      </Box>
                      <Box display='flex' gap={2}>
                        <Typography fontWeight={500} color={grey[600]}>Survey Start:</Typography>
                        <Typography fontWeight={500}>{formattedStart}</Typography>
                      </Box>
                      <Box display='flex' gap={2}>
                        <Typography fontWeight={500} color={grey[600]}>Survey End:</Typography>
                        <Typography fontWeight={500}>{formattedEnd}</Typography>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )
              })
            }
          </>
      }
    </Box>
  )
}
